import React, { ChangeEvent, useState } from 'react';
import './modifica-account.scss';
import { useNavigate } from 'react-router-dom';
import UserService from '../../service/user-service';
import {PHONE_REGEX, ROUTES} from '../../constant/constant';
import ReCAPTCHA from 'react-google-recaptcha';

function ModificaAccount() {

  const siteKey: string = process.env.REACT_APP_LOCAL_SITE_KEY || '';
  const navigateTo = useNavigate();
  const [error, setError] = useState({ errorLabel: '', isPhoneCorrect: false, isCaptchaEvaluated: false });
  const [phoneNumber, setPhoneNumber] = useState('');

  const confirm = async () => {
    setError({
      errorLabel: '',
      isPhoneCorrect: false,
      isCaptchaEvaluated: true
    });
    const response = await UserService.generateOtp(phoneNumber);
    setError({
      errorLabel: '',
      isPhoneCorrect: true,
      isCaptchaEvaluated: true
    });
    if (response.code === 0) {
      navigateTo(ROUTES.AUTENTICAZIONE);
    } else if (response.code === -1) {
      navigateTo(ROUTES.AUT_NON_RICONOSCIUTO);
    } else {
      navigateTo(response.description ? `${ROUTES.GENERIC_ERROR}/${response.description}` : ROUTES.GENERIC_ERROR);
    }
  }

  // eslint-disable-next-line no-undef
  const digitPhone = (event: ChangeEvent<HTMLInputElement>) => {
    const phoneNumber = event.target.value;
    if (PHONE_REGEX.test(phoneNumber)) {
      setPhoneNumber(phoneNumber);
      setError({
        errorLabel: '',
        isPhoneCorrect: true,
        isCaptchaEvaluated: error.isCaptchaEvaluated
      });
    } else {
      setError({
        errorLabel: 'Il numero inserito non è valido',
        isPhoneCorrect: false,
        isCaptchaEvaluated: error.isCaptchaEvaluated
      });
    }
  }

  const onCaptchaChange = () => {
    setError({
      errorLabel: '',
      isPhoneCorrect: error.isPhoneCorrect,
      isCaptchaEvaluated: true
    });
  }

  const onCaptchaErrored = () => {
    setError({
      errorLabel: '',
      isPhoneCorrect: error.isPhoneCorrect,
      isCaptchaEvaluated: false
    });
  }

  return (
    <div className="ModificaAccount">
      <div className="page-container">
        <h3 className="page-title-success">Modifica account</h3>
        <p>Da questa pagina puoi modificare i tuoi consensi o cancellare il tuo account Wi-Fi.</p>
        <p>
          Digita il numero di telefono utilizzato in fase di registrazione per ricevere il codice con cui autenticarti.
        </p>

        <div className="input-element">
          <span className="input-title">Cellulare</span>
          <span className="text-gray">Inserisci anche il prefisso (es. +39) se l'hai utilizzato in fase di registrazione</span>
          <input type="phone" size={18} maxLength={13} property="cellulare" alt="Cellulare" onChange={digitPhone} className={error.errorLabel !== '' ? 'input-border-error' : ''} />
          <span className="input-error">{error.errorLabel}</span>
        </div>

        <div className="captcha">
          <ReCAPTCHA sitekey={siteKey} onChange={onCaptchaChange} onErrored={onCaptchaErrored} onExpired={onCaptchaErrored} />
        </div>
        <button className="confirm-btn" onClick={confirm} disabled={!error.isPhoneCorrect || !error.isCaptchaEvaluated}>Conferma</button>
      </div>
    </div>
  );
}

export default ModificaAccount;
